export function trimAndLowerText(text) {
    return typeof text === 'string' ? text.trim().toLowerCase() : text;
}
